document.addEventListener('DOMContentLoaded', function() {
  
  const sections = document.querySelectorAll('.collection-row');

  sections.forEach(section => {
    const track = section.querySelector('.collection-row__track');
    const scrollbarTrack = section.querySelector('.custom-scrollbar-track');
    const thumb = section.querySelector('.custom-scrollbar-thumb');
    const leftBtn = section.querySelector('.scroll-btn.left');
    const rightBtn = section.querySelector('.scroll-btn.right');
    const scrollAmount = 300;

    if (!track) return;

    // --- 1. BUTTONS ---
    if (leftBtn) {
      leftBtn.addEventListener('click', () => {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
    }

    if (rightBtn) {
      rightBtn.addEventListener('click', () => {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }

    // --- 2. SYNC SCROLLBAR & ARROW STATES ---
    let isDraggingThumb = false;

    const updateUI = () => {
      // A. Update Scrollbar (only if not dragging)
      if (!isDraggingThumb) {
        const scrollRatio = track.clientWidth / track.scrollWidth;
        const thumbWidthPercent = Math.min(Math.max(scrollRatio * 100, 10), 100);
        thumb.style.width = `${thumbWidthPercent}%`;

        const maxScrollLeft = track.scrollWidth - track.clientWidth;
        const scrollPercentage = maxScrollLeft > 0 ? track.scrollLeft / maxScrollLeft : 0;
        
        const availableSpace = 100 - thumbWidthPercent;
        const thumbPosition = scrollPercentage * availableSpace;

        requestAnimationFrame(() => {
          thumb.style.left = `${thumbPosition}%`;
        });
      }

      // B. Update Arrow States
      // Allow a tiny 2px buffer for rounding errors in some browsers
      const maxScroll = track.scrollWidth - track.clientWidth;
      
      if (leftBtn) {
        if (track.scrollLeft <= 2) {
          leftBtn.classList.add('disabled');
        } else {
          leftBtn.classList.remove('disabled');
        }
      }

      if (rightBtn) {
        if (track.scrollLeft >= maxScroll - 2) {
          rightBtn.classList.add('disabled');
        } else {
          rightBtn.classList.remove('disabled');
        }
      }
    };

    track.addEventListener('scroll', updateUI);
    window.addEventListener('resize', updateUI);
    window.addEventListener('load', updateUI);
    // Run immediately to disable Left Arrow on load
    updateUI();


    // --- 3. DRAG SCROLLBAR THUMB (MOUSE & TOUCH) ---
    let startX;
    let scrollLeftStart;

    if (thumb) {
      const handleDragStart = (pageX) => {
        isDraggingThumb = true;
        thumb.classList.add('active');
        startX = pageX;
        scrollLeftStart = track.scrollLeft;
      };

      const handleDragMove = (pageX) => {
        if (!isDraggingThumb) return;
        
        const walk = pageX - startX;
        const availableWidth = scrollbarTrack.clientWidth - thumb.clientWidth;
        const maxScrollableWidth = track.scrollWidth - track.clientWidth;
        const scrollRatio = maxScrollableWidth / availableWidth;

        track.scrollLeft = scrollLeftStart + (walk * scrollRatio);

        // Manual visual update for immediate responsiveness
        const newScrollPercentage = track.scrollLeft / maxScrollableWidth;
        const thumbWidthPercent = parseFloat(thumb.style.width);
        const availableSpace = 100 - thumbWidthPercent;
        const newThumbPos = newScrollPercentage * availableSpace;

        thumb.style.left = `${Math.min(Math.max(newThumbPos, 0), availableSpace)}%`;
      };

      const handleDragEnd = () => {
        isDraggingThumb = false;
        thumb.classList.remove('active');
        // Force one final check to update arrows correctly
        updateUI();
      };

      // Mouse Events
      thumb.addEventListener('mousedown', (e) => { e.preventDefault(); handleDragStart(e.pageX); });
      window.addEventListener('mousemove', (e) => { if (isDraggingThumb) { e.preventDefault(); handleDragMove(e.pageX); } });
      window.addEventListener('mouseup', handleDragEnd);

      // Touch Events
      thumb.addEventListener('touchstart', (e) => { e.preventDefault(); handleDragStart(e.touches[0].pageX); }, { passive: false });
      window.addEventListener('touchmove', (e) => { if (isDraggingThumb) { e.preventDefault(); handleDragMove(e.touches[0].pageX); } }, { passive: false });
      window.addEventListener('touchend', handleDragEnd);
    }


    // --- 4. DRAG TO SWIPE IMAGES ---
    let isDown = false;
    let startX_track;
    let scrollLeft_track;
    let isDragging = false; 

    const imagesAndLinks = track.querySelectorAll('img, a');
    imagesAndLinks.forEach(el => {
      el.addEventListener('dragstart', (e) => e.preventDefault());
    });

    track.addEventListener('mousedown', (e) => {
      isDown = true;
      isDragging = false; 
      track.classList.add('active');
      startX_track = e.pageX - track.offsetLeft;
      scrollLeft_track = track.scrollLeft;
    });

    const stopDragging = () => {
      isDown = false;
      track.classList.remove('active');
    };

    track.addEventListener('mouseleave', stopDragging);
    track.addEventListener('mouseup', stopDragging);

    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX_track) * 2; 
      
      if (Math.abs(walk) > 5) isDragging = true;
      track.scrollLeft = scrollLeft_track - walk;
    });

    const links = track.querySelectorAll('a');
    links.forEach(link => {
      link.addEventListener('click', (e) => {
        if (isDragging) {
          e.preventDefault(); 
          e.stopImmediatePropagation(); 
        }
      });
    });


    // --- 5. SCROLL HINT (THE CENTERED NUDGE) ---
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const t = entry.target;
          
          setTimeout(() => {
             if (t.scrollLeft === 0 && !t.classList.contains('user-interacted')) {
                t.scrollBy({ left: 60, behavior: 'smooth' });
                setTimeout(() => {
                   t.scrollBy({ left: -60, behavior: 'smooth' });
                }, 400);
             }
          }, 300);
          
          obs.unobserve(t); 
        }
      });
    }, { rootMargin: "-35% 0px -35% 0px", threshold: 0.2 });

    observer.observe(track);
    
    track.addEventListener('scroll', () => {
        if (track.scrollLeft > 5) track.classList.add('user-interacted');
    }, { once: true });

  });


  // --- 6. FORMAT TITLES ---
  const titles = document.querySelectorAll('.collection-card__title');
  titles.forEach(title => {
    const text = title.textContent.trim();
    if (/collection$/i.test(text)) {
      const updated = text.replace(/(.*)\s(Collection)$/i, '$1<br><span class="collection-line-2">$2</span>');
      title.innerHTML = updated;
    }
  });

});